import React from 'react'
import { reactular } from '@vendhq/reactular'
import { ErrorMessage } from '@lightspeed/design-system-react'
import { noWidow } from '@vend/utilities'
import { useT } from '@transifex/react'

export const HasCCErrorMessage = () => {
  const t = useT()
  return (
    <ErrorMessage>
      {noWidow(
        t(
          'You’ve entered information that looks like credit card details, which could be highly sensitive. Please remove them to continue.',
          { _context: 'Error message' }
        )
      )}
    </ErrorMessage>
  )
}

export const HasCCErrorMessageComponent = reactular(
  HasCCErrorMessage,
  [],
  'reactWrapper'
)
